import { Link } from 'react-router-dom';
import { useSiteData } from '@/data/siteData';
import VehicleCard from '@/pages/home/components/VehicleCard';

export default function AllVehiclesList() {
  const { vehicles, loading } = useSiteData();

  return (
    <div className="w-full px-4 md:px-6 lg:px-10 py-8 md:py-12">
      <div className="mb-8 md:mb-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            Tous nos véhicules d'occasion
          </h1>
          <p className="text-foreground-600 mt-2 text-sm md:text-base">
            {loading ? 'Chargement…' : `${vehicles.length} véhicule${vehicles.length > 1 ? 's' : ''} disponible${vehicles.length > 1 ? 's' : ''} dans nos parcs du Tampon et de Saint-Pierre`}
          </p>
        </div>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-foreground-300 text-foreground-700 font-label font-medium text-sm hover:border-primary-500 hover:text-primary-500 transition-all whitespace-nowrap"
        >
          <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center" />
          Retour à l'accueil
        </Link>
      </div>

      {!loading && vehicles.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-product-shop>
          {vehicles.map((vehicle, idx) => (
            <VehicleCard key={vehicle.id} vehicle={vehicle} index={idx} />
          ))}
        </div>
      ) : !loading ? (
        <p className="text-foreground-500">Aucun véhicule publié pour le moment.</p>
      ) : null}

      <div className="text-center mt-10 md:mt-12 flex flex-col sm:flex-row items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-foreground-300 text-foreground-700 font-label font-medium text-sm hover:border-primary-500 hover:text-primary-500 transition-all whitespace-nowrap"
        >
          <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center" />
          Retour à l'accueil
        </Link>
        <a
          href="tel:+262692505551"
          className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-white font-label font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap"
        >
          <i className="ri-phone-line w-4 h-4 flex items-center justify-center" />
          Nous appeler
        </a>
      </div>
    </div>
  );
}
